import { render, staticRenderFns } from "./PSEkle.vue?vue&type=template&id=6004c310&scoped=true&"
import script from "./PSEkle.vue?vue&type=script&lang=js&"
export * from "./PSEkle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6004c310",
  null
  
)

export default component.exports